import { USER_ROLES } from "constants";
import React from "react";

const { useSelector } = require("react-redux");
const { Navigate, useLocation } = require("react-router-dom");

const HandleUserRouteRestrictRedirect = ({ children }) => {
    const authData = useSelector(s => s.auth.data);
    const location = useLocation();
    const { pathname } = location;
    const basePath = pathname.split('/').slice(1, 3).join('/');

    if (
        ["portal/mission-cc", "portal/mission-process"].includes(basePath) 
        && authData?.has_active_mission === false
    ) {
        return <Navigate to="/" replace />;
    }

    return (
        <React.Fragment>{children}</React.Fragment>
    );
}

export default HandleUserRouteRestrictRedirect;